import { Theme } from '@mui/material'

const useStyles = {
  modalHeader: {
    fontSize: '24px',
    fontWeight: 300,
    lineHeight: '32px',
    letterSpacing: '0',
  },
  helpIconButton: (theme: Theme) => ({
    backgroundColor: theme.palette.secondary.light,
    opacity: 1,
  }),
  chatWithUsButton: (theme: Theme) => ({
    backgroundColor: theme.palette.secondary.light,
    opacity: 1,
    color: theme.palette.secondary.dark,
  }),
  desktopPhoneIcon: (theme: Theme) => ({
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: 40,
    height: 40,
    borderRadius: '50%',
    backgroundColor: theme.palette.secondary.light,
  }),
  contentContainer: {
    direction: 'column',
    gap: 3,
  },
  contactRow: {
    alignItems: 'center',
    justifyContent: 'space-between',
    width: '100%',
  },
  phoneRow: {
    alignItems: 'center',
    justifyContent: 'space-between',
    width: '100%',
  },
  disclaimerText: (theme: Theme) => ({
    color: theme.palette.text.secondary,
  }),
  disclaimerHeader: (theme: Theme) => ({
    color: theme.palette.text.secondary,
    marginBottom: theme.spacing(3),
    textAlign: 'center',
  }),
  disclaimerButtonContainer: {
    marginTop: 3,
    display: 'flex',
    justifyContent: 'center',
    width: '100%',
  },
  disclaimerCloseButton: (theme: Theme) => ({
    backgroundColor: theme.palette.secondary.light,
    opacity: 1,
    color: theme.palette.secondary.dark,
  }),
  descriptionText: (theme: Theme) => ({
    marginTop: 1,
    color: theme.palette.text.secondary,
  }),
  phoneIconContainer: {
    marginLeft: 'auto',
  },
  phoneIcon: (theme: Theme) => ({
    color: theme.palette.text.secondary,
  }),
  disclaimerContainer: {
    marginTop: 0,
  },
  disclaimerBodyText: (theme: Theme) => ({
    color: theme.palette.text.secondary,
    fontSize: '0.875rem',
  }),
  disclaimerLink: (theme: Theme) => ({
    fontSize: 'inherit',
    color: theme.palette.primary.main,
    textDecoration: 'underline',
    cursor: 'pointer',
    verticalAlign: 'baseline',
  }),
}

export default useStyles
